import createNetworkingClient from 'utils/networking-client';
import { devLog } from 'utils/dev-utils';
import { StatusCodes } from 'http-status-codes';
import { FOLLOWING_STATUS } from '../../constants/follows/following-constants';

/**
 *  Follows an athlete on strava.
 *
 * @param {Object} param
 * @param {string} param.followerId - id for the athlete who is requesting the follow
 * @param {string} param.followingId - id for the athlete to be followed
 * @returns {Promise<FOLLOWING_STATUS>} - enum value PENDING or FOLLOWING
 */
export const followAthlete = ({ followerId, followingId }) => {
  return new Promise((resolve) => {
    createNetworkingClient()
      .post(`/athletes/${followerId}/follows`, {
        follow: {
          follower_id: followerId,
          following_id: followingId
        }
      })
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          const { data } = response;
          if (data.approved) {
            resolve(FOLLOWING_STATUS.following);
          } else {
            resolve(FOLLOWING_STATUS.pending);
          }
        } else {
          resolve(FOLLOWING_STATUS.error);
          // TODO log sentry error
        }
      })
      .catch(() => {
        resolve(FOLLOWING_STATUS.error);
        // TODO log sentry error
      });
  });
};

export const unfollowAthlete = ({ followerId, followingId }) => {
  return new Promise((resolve) => {
    createNetworkingClient()
      .delete(
        `/athletes/${followerId}/follows/${followingId}`,
        {
          data: {
            follow: {
              follower_id: followerId,
              following_id: followingId
            }
          }
        },
        { headers: { Accept: 'text/javascript' } }
      )
      .then((response) => {
        if (response?.status === StatusCodes.NO_CONTENT) {
          resolve(true);
        } else {
          devLog(response);
          resolve(false);
        }
      })
      .catch((e) => {
        devLog(e);
        resolve(false);
      });
  });
};

/**
 * Gets suggested follow list
 *
 * @param {Object} param
 * @param {string} param.callsite - source making the get request
 * @returns {Promise<Array>} - list of suggested friends to follow
 */
export const getSuggestedFollows = ({ callsite }) => {
  return new Promise((resolve, reject) => {
    createNetworkingClient()
      .get('/athlete/suggested_follows', {
        params: { callsite }
      })
      .then((response) => {
        if (response?.status === StatusCodes.OK) {
          const { data } = response;
          resolve(data);
        } else {
          devLog(response.error);
          resolve(response.error);
        }
      })
      .catch((e) => {
        devLog(e);
        reject(e);
      });
  });
};

export default { followAthlete, unfollowAthlete, getSuggestedFollows };
